// @flow
import React, { Component } from 'react';

type Props = {
  label: string,
  value: boolean,
  onChange: () => void,
};

type State = {
  id: string,
};

const styles = {
  checkboxWidget: {
    display: 'flex',
    alignItems: 'center',
  },
};

let instanceId = -1;

class CheckboxWidget extends Component<Props, State> {
  constructor(...args: any) {
    super(...args);

    const id = `checkbox-widget-${instanceId += 1}`;

    this.state = { id };
  }

  render() {
    return (
      <label
        htmlFor={this.state.id}
        style={styles.checkboxWidget}
      >
        <input
          id={this.state.id}
          type="checkbox"
          checked={this.props.value}
          onChange={this.props.onChange}
        />
        <span>{this.props.label}</span>
      </label>
    );
  }
}

export default CheckboxWidget;



// WEBPACK FOOTER //
// ./demo/src/checkbox-widget.js